import { Subject } from 'rxjs';

/**
 * Collezione di filtri comunicata ai service provider
 * per l'ottenimento dell'insieme di dati filtrato
 */
export abstract class EntitiesFilter {
  /**
   * Quanto tempo deve passare prima della propagazione
   * di un cambiamento della raccolta dei filtri
   */
  debounceTimeMs = 1000;
  /**
   * ChangeSubject che emette lo stream dei cambiamenti 
   * dei filtri
   * - Ogni setter nelle classi figlie vi invoca il next
   * - Viene osservato direttamente nella GenericListPage
   * invocando il metodo
   */
  filterChangeSubject: Subject<any> = new Subject<any>();
  /**
   * Pulizia di tutte le chiavi di filtro
   */
  abstract reset(): void;
  /**
   * Ritorna il numero di campi di filtro effettivamente valorizzati
   * in un dato istante
   * (itera sulle proprieta' enumberabili dell'oggetto cioe' i
   * suoi campi)
   */
  getNumberOfActiveFilters(): number {
    const significativeThis = Object.assign({}, this);
    delete significativeThis['filterChangeSubject'];
    delete significativeThis['debounceTimeMs'];
    let numberOfActiveFilters = 0;
    for (const key in significativeThis) {
      if (significativeThis[key]) { // falsy value cioe' '' o undefined
        numberOfActiveFilters++;
      }
    }
    return numberOfActiveFilters;
  }

  /**
   * Ritorna il numero di campi di filtro NON valorizzati
   * in un dato istante
   * (itera sulle proprieta' enumberabili dell'oggetto cioe' i
   * suoi campi)
   */
  getNumberOfINActiveFilters(): number {
    const significativeThis = Object.assign({}, this);
    delete significativeThis['filterChangeSubject'];
    delete significativeThis['debounceTimeMs'];
    let numberOfInactiveFilters = 0;
    for (const key in significativeThis) {
      if (!significativeThis[key]) { // falsy value cioe' '' o undefined
        numberOfInactiveFilters++;
      }
    }
    return numberOfInactiveFilters;
  }

  /**
   * Ritorna TRUE se il conteggio dei filtri ritornato 
   * da @see getNumberActiveFilters() > 0
   */
  isSomeFilterActive(): boolean {
    const numberOfActiveFilters = this.getNumberOfActiveFilters();
    return numberOfActiveFilters > 0;
  }

  /**
   * Metodo necessario per evitare crash di serializzazione dovuti
   * alla presenza di un Subject nello stato interno
   * TODO: incorporare ed esporre in questa entita' il filtro applicativo 
   */
  toJSON() {
    const publicThis = Object.assign({}, this);
    delete publicThis['filterChangeSubject'];
    delete publicThis['debounceTimeMs'];
    return publicThis;
  }
}
